import { jsx } from "@emotion/react/jsx-runtime";
import headingLevelContext from "./headingLevelContext.mjs";
import { forwardRef, useContext } from "react";
const H = forwardRef(function H2(_ref, ref) {
  let {
    adjustLevel = 0,
    ...props
  } = _ref;
  let level = Math.min(6, useContext(headingLevelContext) + adjustLevel);
  let Element = `h${level}`;
  return /* @__PURE__ */jsx(Element, {
    ref,
    ...props
  });
});
export { H as default };